import React from "react";
import "./index.css";
import prizeSilver from "../../assets/images/prize-silver.svg";
import prizeGold from "../../assets/images/prize-gold.svg";
import redeemedPrize from "../../assets/images/prize.svg";
import { useIsDesktop } from "../../helpers/useIsDesktop";

const PrizeCard = ({ category }) => {
  const levels = {
    1: { name: "Bronce", bg: "linear-gradient(to right, #B924B4, #8525B7)" },
    2: { name: "Silver", bg: "linear-gradient(to right, #C0C0C0, #EEEEEF)" },
    3: {
      name: "Gold",
      bg: "linear-gradient(to right, #ECA109, #FAD26A, #ED8E09)"
    }
  };

  const seals = {
    1: {
      values: [redeemedPrize, 2, 3, prizeSilver, 5, 6, 7, 8, 9, prizeGold],
      border: "border-bronce"
    },
    2: {
      values: ["X", "X", "X", redeemedPrize, 5, 6, 7, 8, 9, prizeGold],
      border: "border-silver"
    },
    3: {
      values: ["X", "X", "X", "X", "X", "X", "X", "X", "X", prizeGold],
      border: "border-gold"
    }
  };

  const activeSeal = {
    1: { value: 0 },
    2: { value: 3 },
    3: { value: 9 }
  };

  const selectedCategory = levels[category];
  const selectSeals = seals[category];
  const selectActiveSeal = activeSeal[category];
  const isDesktop = useIsDesktop();

  return (
    <div
      className={`prize-card d-flex flex-column justify-content-center ${
        isDesktop ? "mt-5" : ""
      }`}
      style={{ background: selectedCategory.bg }}
    >
      <div className="text-white text-center card-title mt-3">
        {selectedCategory.name.toUpperCase()}
      </div>
      <div className="d-flex flex-wrap mt-2 justify-content-center align-items-center">
        {Array.from({ length: 10 }, (_, index) => (
          <div
            key={index}
            className={`card-icon m-2 my-3 ${selectSeals.border} ${
              selectActiveSeal.value === index ? "active-card-icon" : "m-1"
            } ${selectSeals.values[index] === "X" ? "seal-redeemed" : ""}`}
          >
            {!isNaN(selectSeals.values[index]) ? (
              <span className="seal-icon">{selectSeals.values[index]}</span>
            ) : selectSeals.values[index] === "X" ? (
              <span className="seal-icon text-white opacity-50">X</span>
            ) : (
              <img
                src={selectSeals.values[index]}
                alt="Prize"
                className="gift-seal"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrizeCard;
